<script setup lang="ts">
import { computed, watch } from 'vue';
import { Alert, Spin } from 'ant-design-vue';

import { useLoadImage } from './useLoad';

const props = defineProps<{ url: string }>();
const { loading, error } = useLoadImage(computed(() => props.url));
const isError = defineModel<boolean>('isError');
watch(error, (newError) => {
  isError.value = !!newError;
}, { immediate: true });
</script>

<template>
  <div v-if="loading" class="flex items-center justify-center p-6">
    <Spin tip="Loading preview image." />
  </div>
  <Alert
    v-else-if="error"
    type="error"
    show-icon
    message="Error"
    description="Preview image not available."
  />
  <img
    v-else
    :src="url"
    alt="Renters policy coverage file preview"
    class="max-w-full h-auto"
  >
</template>
